module.exports = __webpack_public_path__ + "static/media/diana.4caf614b.jpg";